// extracted by mini-css-extract-plugin
export var completionBody = "_c3-2";
export var completionCard = "_c3-0";
export var completionFooter = "_c3-3";
export var completionTitle = "_c3-1";